import { render, staticRenderFns } from "./Email-Reminder.vue?vue&type=template&id=55b86ae7"
import script from "./Email-Reminder.vue?vue&type=script&lang=js"
export * from "./Email-Reminder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports